"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const index_wrapper_1 = __importDefault(require("@Components/WorkItem/index-wrapper"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const RegistrationDraftsTable = (props) => {
    const { rightsholderStore, workSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { openDeleteModal } = props;
    const workDrafts = workSearchStore.worksDraftsRightsHolder;
    return (react_1.default.createElement("section", { className: 'items-container' }, workDrafts === null || workDrafts === void 0 ? void 0 :
        workDrafts.works.map((item, index) => (react_1.default.createElement(index_wrapper_1.default, { key: item.id ? item.id : index, data: item, rightsHolderId: rightsholderStore.currentRightsholderId, draftType: true, handleDeleteDraft: () => openDeleteModal(false, item.title, item.id ? item.id : index) }))),
        workDrafts && workDrafts.count < 1 && react_1.default.createElement("p", { className: 'small no-results' }, "No results")));
};
exports.default = (0, mobx_react_1.observer)(RegistrationDraftsTable);
